// extracted by mini-css-extract-plugin
export var shake = "_h-1";
export var toastCloseButton = "_h-0";